import React from 'react';
import PropTypes from 'prop-types';

class PortalToastrContent extends React.PureComponent {
    constructor(props) {
        super(props);
    }

    cutMessage(){
        let message = this.props.message.substring(0,this.props.maxNumberOfCharacters),
            ellipsis = '...';
        
        return message.concat(ellipsis);

    }

    render() {
        return (
            <div className={`toastr-content-wrapper ${this.props.toastrClassname}`}>
                <span className='toastr-icon'>
                    <span className={this.props.iconClass ? this.props.iconClass : ''}/>
                </span>
                <span className='toastr-message-wrapper'>
                    <span className='toastr-message' title={this.props.message}>
                        {this.props.maxNumberOfCharacters && this.props.message.length > this.props.maxNumberOfCharacters ? this.cutMessage() : this.props.message}
                    </span>
                </span>
            </div>
        );
    }
}


PortalToastrContent.propTypes = {
    iconClass: PropTypes.string,
    message: PropTypes.string.isRequired
};


export default PortalToastrContent;